import { FiltroGlosasEmpleador, GestionGlosasMasivo, GlosaEmpleador, RespuestaGestionGlosas } from "../modelo/GlosaEmpleador";
import { OrdenamientoGlosas } from "../modelo/OrdenamientoGlosas";

export const CONSULTAR_GLOSAS = "CONSULTAR_GLOSAS";
export const GLOSAS_CONSULTADAS = "GLOSAS_CONSULTADAS";
export const ERROR_CONSULTANDO_GLOSAS = "ERROR_CONSULTANDO_GLOSAS";

export const INICIAR_GESTION_GLOSAS = "INICIAR_GESTION_GLOSAS";
export const GESTIONAR_GLOSAS = "GESTIONAR_GLOSAS";
export const GLOSAS_ENVIADAS = "GLOSAS_ENVIADAS";
export const GLOSA_GESTIONADA = "GLOSA_GESTIONADA";
export const ERROR_GESTIONANDO_GLOSA = "ERROR_GESTIONANDO_GLOSA";
export const ERROR_AUTORIZACION_GESTION_GLOSAS = "ERROR_AUTORIZACION_GESTION_GLOSAS";

export const OBTENER_XLS_DATOS_GLOSAS = "OBTENER_XLS_DATOS_GLOSAS";
export const XLS_DATOS_GLOSAS_OBTENIDO = "XLS_DATOS_GLOSAS_OBTENIDO";
export const ERROR_OBTENIENDO_XLS_DATOS_GLOSAS = "ERROR_OBTENIENDO_XLS_DATOS_GLOSAS";

export const GESTIONAR_MASIVO_GLOSAS = "GESTIONAR_MASIVO_GLOSAS";
export const MASIVO_GLOSAS_GESTIONADO = "MASIVO_GLOSAS_GESTIONADO";
export const ERROR_GESTIONANDO_MASIVO_GLOSAS = "ERROR_GESTIONANDO_MASIVO_GLOSAS";

export const iniciarGestionGlosas = (totalGlosasGestion: number) => ({ type: INICIAR_GESTION_GLOSAS, totalGlosasGestion });
export const consultarGlosas = (filtroGlosasEmpleador: FiltroGlosasEmpleador, ordenamiento: OrdenamientoGlosas) => ({ type: CONSULTAR_GLOSAS, filtroGlosasEmpleador, ordenamiento });
export const glosasConsultadas = (glosasEmpleador: Array<GlosaEmpleador>, paginas: number, totalGlosasEmpleador: number) => ({ 
    type: GLOSAS_CONSULTADAS, glosasEmpleador, paginas, totalGlosasEmpleador 
});
export const errorConsultandoGlosas = () => ({ type: ERROR_CONSULTANDO_GLOSAS });

export const gestionarGlosas =
    (glosaEmpleador: GlosaEmpleador, numgestion: number, totalgestiones: number, codigoProceso: number, observacion: string, dniUsuarioGestion: string, fechaEnvio: string) => ({ 
                                            type: GESTIONAR_GLOSAS, glosaEmpleador, numgestion, totalgestiones, codigoProceso, observacion, dniUsuarioGestion, fechaEnvio});
export const glosasEnviadas = (respuestaGestionGlosa: RespuestaGestionGlosas) => ({ type: GLOSAS_ENVIADAS, respuestaGestionGlosa });
export const glosaGestionada = (respuestaGestionGlosa: RespuestaGestionGlosas) => ({ type: GLOSA_GESTIONADA, respuestaGestionGlosa });
export const errorGestionandoGlosa = (respuestaGestionGlosa: RespuestaGestionGlosas) => ({ type: ERROR_GESTIONANDO_GLOSA, respuestaGestionGlosa });
export const errorAutorizacionGestionGlosas = () => ({ type: ERROR_AUTORIZACION_GESTION_GLOSAS});

export const obtenerXLSDatosGlosas = (filtroGlosasEmpleador: FiltroGlosasEmpleador) => ({ type: OBTENER_XLS_DATOS_GLOSAS, filtroGlosasEmpleador });
export const XLSDatosGlosasObtenido = () => ({ type: XLS_DATOS_GLOSAS_OBTENIDO });
export const errorObteniendoXLSDatosGlosas = () => ({ type: ERROR_OBTENIENDO_XLS_DATOS_GLOSAS });

export const gestionarMasivoGlosas = (gestionGlosasMasivo: GestionGlosasMasivo) => ({ type: GESTIONAR_MASIVO_GLOSAS, gestionGlosasMasivo });
export const masivoGlosasGestionado = (mensajeRespuesta: string, solicitudExito: boolean, datos: string) => ({ type: MASIVO_GLOSAS_GESTIONADO, mensajeRespuesta, solicitudExito, datos });
export const errorGestionandoMasivoGlosas = (mensajeRespuesta: string) => ({ type: ERROR_GESTIONANDO_MASIVO_GLOSAS, mensajeRespuesta });






// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modulos/bandejaGlosasActions.ts